import {useEffect, useMemo, useState} from 'react'
import {useTable} from 'react-table'
import {CustomHeaderColumn} from '../table/columns/CustomHeaderColumn'
import {CustomRow} from '../table/columns/CustomRow'
import {usersColumns} from './columns/_columns'
import {UsersListLoading} from '../components/loading/UsersListLoading'
import {KTCardBody} from '../../../../../../_metronic/helpers'
import api from '../../../../../utils/Api'
import {useTableSortQuery} from '../../../../../components/grid/tableSort'
import Pagination from '../../../../../components/Pagination'
import {useLocation, useParams} from 'react-router-dom'
import {IncomeDocumentStateTypes, IncomeDocumentTypes} from '../../../../../constants/Common'
import {useAuth} from '../../../../auth/core/Auth'

const UsersTable = ({s = '', params = {}}) => {
  const [data, setData] = useState([])
  const { state } = useParams()
  const location = useLocation()
  const isInExpensePurchaseOrderAssetPage = location.pathname.includes("expense-purchase-asset-order");
  const [pagination, setPagination] = useState({total: 1, last_page: 1, current_page: 1})
  const [loading, setLoading] = useState(false)
  const {total, last_page, current_page} = pagination
  const {can} = useAuth()
  const canCancelDocument = can('accounting_purchase_order_edit')

  const sortQuery = useTableSortQuery()

  const fetch = (page = 1, _params = {})=>{
    api.request('account/income-document', ({data, meta}) => {
      setData(data)
      setPagination(meta)
    }, {
      s,
      type: isInExpensePurchaseOrderAssetPage ? IncomeDocumentTypes.EXPENSE_PURCHASE_ASSET_ORDER : IncomeDocumentTypes.EXPENSE_PURCHASE_ORDER,
      ...params,
      ..._params,
      ...sortQuery,
      page
    })
  }

  const handleCancelDocument = (doc: any) => {
    if (!doc?.id) return
    if (!canCancelDocument) return
    const code = doc?.code ? ` (${doc.code})` : ''
    if (!window.confirm(`ยืนยันยกเลิกเอกสาร${code} ?`)) return

    api.request(
      `account/income-document/${doc.id}`,
      (_res, success) => {
        if (!success) return
        fetch(current_page)
      },
      api.form({state: IncomeDocumentStateTypes.VOIDED}, null),
      'PATCH',
      {showSuccess: true}
    )
  }

  const columns = useMemo(
    ()=>usersColumns(() => fetch(), handleCancelDocument, canCancelDocument),
    [current_page, canCancelDocument]
  )
  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data,
  })

  useEffect(()=>{
    fetch()
  }, [s, params, sortQuery.sort, sortQuery.order])

  return (
    <KTCardBody className='py-4'>
      <div className='table-responsive'>
        <table
          id='kt_table_users'
          className='table table-striped align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
          {...getTableProps()}
        >
          <thead>
            <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
              {headers.map((column: any) => (
                <CustomHeaderColumn key={column.id} column={column} />
              ))}
            </tr>
          </thead>
          <tbody className='text-gray-600 fw-bold' {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row: any, i) => {
                prepareRow(row)
                return <CustomRow row={row} key={`row-${i}-${row.id}`} />
              })
            ) : (
              <tr>
                <td colSpan={8}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                    No matching records found
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {loading && <UsersListLoading />}
      <div className="float-end py-5">
      <Pagination
      goToPage={(p)=>fetch(p)}
      lastPage={last_page}
       page={current_page} />
      {/*<UsersListPagination />*/}
      </div>
    </KTCardBody>
  )
}

export {UsersTable}
